module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.8e4b8ea3.jpg";